<template>
  <div class="p-4 bg-white rounded-lg h-100 poppins" v-if="pageData">
    <datatable-detail
      :table_properties="pageData?.properties"
    ></datatable-detail>
    <div class="row px-4 py-6 d-block">
      <div class="col-12 text-h6 font-weight-bold text--disabled py-0 my-0">
        Input
      </div>
      <div class="col-12 row ma-0 pa-0">
        <div class="col-5 col-md-3 poppins">
          <v-autocomplete
            :items="pageData.data.countries"
            item-text="text"
            item-value="index"
            outlined
            :label="$t('country_code')"
            v-model="formData.country_code"
            :error-messages="country_codeErrors"
            clearable
            @input="$v.formData.country_code.$touch()"
            @blur="$v.formData.country_code.$touch()"
          ></v-autocomplete>
        </div>
        <div class="col-7 col-md-9">
          <v-text-field
            outlined
            :label="$t('phone')"
            v-model="formData.phone"
            :error-messages="phoneErrors"
            clearable
            @input="$v.formData.phone.$touch()"
            @blur="$v.formData.phone.$touch()"
          ></v-text-field>
        </div>
      </div>
      <div class="col-12 d-flex justify-center pa-0 ma-0">
        <button @click.prevent="resetData" class="btn btn-secondary mx-1">
          <span class="svg-icon">
            <v-icon size="18">mdi-refresh</v-icon>
          </span>
          Reset
        </button>
        <button @click.prevent="submitData" class="btn btn--export-filter mx-1">
          <span class="svg-icon">
            <v-icon size="18">mdi-check-network-outline</v-icon>
          </span>
          Validate
        </button>
      </div>
      <div class="col-12">
        <div class="text-h6 font-weight-bold text--disabled pb-4">Output</div>
        <div class="border pa-4" style="border-radius: 10px">
          <span class="font-size-lg poppins" v-if="result">{{ result }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import DatatableDetail from "@/own/components/datatable/DatatableDetail";
import ApiService from "@/core/services/api.service";
import validationMixin from "@/own/mixins/validationMixin";
import { required } from "vuelidate/lib/validators";
export default {
  name: "PhoneValidator",
  components: { DatatableDetail },
  mixins: [validationMixin],
  validations() {
    return {
      formData: {
        phone: {
          required,
        },
        country_code: {
          required,
        },
      },
    };
  },
  data: () => ({
    formData: {
      phone: "+501 23 45 67",
      country_code: "AE",
    },
    serverData: {},
    pageData: null,
    result: null, // +971501234567
  }),
  beforeMount() {
    this.loadDataFromServer();
  },
  methods: {
    resetData() {
      this.result = null;
      this.formData.phone = "+501 23 45 67";
      this.formData.country_code = "AE";
      this.serverData = {};
    },
    loadDataFromServer() {
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post("/settings/phone_validator")
        .then(({ data }) => {
          this.pageData = data.data;
        })
        .catch()
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    submitData() {
      this.$store.commit(SET_PAGE_LOADING, true);
      setTimeout(() => {
        // this.result = "+971501234567";
        const digits = this.formData.phone.replace(/\D/g, ""); // keep only numbers
        this.result = "+971" + digits;

        this.$store.commit(SET_PAGE_LOADING, false);
      }, 1000);
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //   return;
      // }
      // this.$store.commit(SET_PAGE_LOADING, true);
      // ApiService.post(
      //   "/settings/phone_validator/phone-correction",
      //   this.formData
      // )
      //   .then(({ data }) => {
      //     this.serverData = data;
      //   })
      //   .finally(() => {
      //     this.$store.commit(SET_PAGE_LOADING, false);
      //   });
    },
  },
  computed: {
    phoneErrors() {
      return this.handleFormValidation("phone", this, "formData");
    },
    country_codeErrors() {
      return this.handleFormValidation("country_code", this, "formData");
    },
  },
};
</script>
